import type { ReactNode, SVGProps } from 'react'

/** Een tekstballon: advies vragen over een vraag of sectie (R-184, mockup 01 van advies). */
export function BubbleIcon(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ width: 'var(--nwo-space-sp-5)', height: 'var(--nwo-space-sp-5)', flexShrink: 0 }}
      focusable="false"
      {...props}
    >
      <path d="M21 15a2 2 0 0 1-2 2H8l-4 4V5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z" />
    </svg>
  )
}
